import { render, staticRenderFns } from "./BrandUpdateDialog.vue?vue&type=template&id=42772ca4&scoped=true"
import script from "./BrandUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./BrandUpdateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42772ca4",
  null
  
)

export default component.exports